import { render, staticRenderFns } from "./Copyright.vue?vue&type=template&id=d0f589fc"
import script from "./Copyright.vue?vue&type=script&lang=js"
export * from "./Copyright.vue?vue&type=script&lang=js"
import style0 from "./Copyright.vue?vue&type=style&index=0&id=d0f589fc&prod&lang=scss"
import style1 from "./Copyright.vue?vue&type=style&index=1&id=d0f589fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports